import React, { useState, useEffect, useRef } from 'react';

const CustomSelectUpdates = ({ selectedType, setSelectedType, noSelectedUpdateInterval }) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  const options = [
    { value: '', label: 'Choose Update Frequency' },
    { value: '24h', label: 'Daily' },
    { value: '3d', label: 'Every 3 Days' },
    { value: '1w', label: 'Weekly' }
  ];

  const handleSelect = (value) => {
    setSelectedType(value);
    setIsOpen(false);
  };

  const handleClickOutside = (event) => {
    if (containerRef.current && !containerRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div ref={containerRef} style={{ position: 'relative', width: '400px' }}>
      <div
        onClick={() => setIsOpen(!isOpen)}
        style={{
          border: noSelectedUpdateInterval ? '1px solid red' : '1px solid #ccc',
          padding: '10px',
          cursor: 'pointer',
          userSelect: 'none',
          background: '#fff',
          borderRadius: '4px'
        }}
        aria-expanded={isOpen}
        aria-haspopup="true"
      >
        {options.find(option => option.value === selectedType)?.label || 'Choose Update Frequency'}
      </div>
      {isOpen && (
        <div
          style={{
            position: 'absolute',
            top: '100%',
            left: 0,
            backgroundColor: 'white',
            border: '1px solid #ccc',
            borderRadius: '4px',
            zIndex: 1000,
            width: '100%',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
          }}
        >
          {options.map(option => (
            <div
              key={option.value}
              onClick={() => handleSelect(option.value)}
              style={{
                padding: '10px',
                cursor: 'pointer',
                backgroundColor: selectedType === option.value ? '#f0f0f0' : 'white',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
              }}
            >
              {option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CustomSelectUpdates;
